import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/trainer/trainer.css";
import "../../styles/home/home.css";
import "../../styles/trainer-member/trainer-member.css";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import { selectAuth } from "../../components/auth/auth.selector";
import CommonFilterStructure from "../../components/common-components/CommonFilterStructure";
import ReportCards from "../../components/trainer-report/ReportCards";
import {
  fetchGTPTreportsStats,
  fetchTrainerReportsStatsData,
} from "../../redux/reducers/apiSlice";
import GTPTreports from "../../components/trainer-report/gt-pt-trainers/GTPTreports";
import HelmetWrapper from "../../HelmetWrapper";

const TrainerReport = () => {
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};

  const dispatch = useDispatch();
  const { trainerReportsStats, gtptReports } = useSelector(
    (state) => state.api
  );

  const isAdmin = user?.account_type === "admin";
  const isGym = user?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(user?.account_type);

  const iniAllFilters = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? user?.name : user?.gym_name || "",
            value: user?.gym_id || user?.uid || user?.user_id || "",
          }
        : "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    gym_id:
      !isAdmin && !isManagerRole
        ? user?.gym_id || user?.uid || user?.user_id
        : "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const iniStatsDatas = {
    allStats: {},
    gtptReportsStats: {},
  };
  const [statsDatas, setStatsDatas] = useState(iniStatsDatas);

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
  };

  function getTrainerReportStats(filters) {
    dispatch(
      fetchTrainerReportsStatsData({
        filters: filters,
        token: user?.token,
      })
    );
  }

  function getGTPTTrainerReportStats(filters) {
    const updatedFilters = {
      ...filters,
      type: "card",
    };

    dispatch(
      fetchGTPTreportsStats({
        filters: updatedFilters,
        token: user?.token,
      })
    );
  }

  function getCombinelyReload() {
    getTrainerReportStats(filters);
    getGTPTTrainerReportStats(filters);
  }

  useEffect(() => {
    const nonAdmin = user?.account_type !== "admin" && !isManagerRole;

    setFilters((prevs) => ({
      ...prevs,
      gym_id: nonAdmin
        ? user.gym_id || user?.uid
        : allFilters.selectedGym?.value || "",
    }));
  }, [allFilters, user.gym_id]);

  useEffect(() => {
    getCombinelyReload();
  }, [filters]);

  useEffect(() => {
    if (trainerReportsStats?.status && trainerReportsStats?.data) {
      setStatsDatas((prevs) => ({
        ...prevs,
        allStats: trainerReportsStats.data,
      }));
    } else {
      setStatsDatas((prevs) => ({
        ...prevs,
        allStats: {},
      }));
    }
  }, [trainerReportsStats]);

  useEffect(() => {
    if (gtptReports?.status && gtptReports?.data) {
      setStatsDatas((prevs) => ({
        ...prevs,
        gtptReportsStats: gtptReports.data,
      }));
    } else {
      setStatsDatas((prevs) => ({
        ...prevs,
        gtptReportsStats: {},
      }));
    }
  }, [gtptReports]);

  return (
    <HelmetWrapper title="WTF: Trainer Report">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <MealsStructure
              text={"Trainer Reports"}
              isReload={() => getTrainerReportStats(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CommonFilterStructure
              from={"dashboard-cards"}
              decryptedText={user}
              setFilters={setAllFilters}
              filters={allFilters}
              onClickReset={onClickReset}
              isTop={true}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <ReportCards
              stats={statsDatas.allStats}
              prevAllFilters={allFilters}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <MealsStructure
              text={"Personal/General Trainers"}
              isReload={() => getGTPTTrainerReportStats(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <GTPTreports
              stats={statsDatas.gtptReportsStats}
              prevAllFilters={allFilters}
            />
          </Col>
        </Row>

        {/* {isAdmin && (
          <Row>
            <Col>
              <StaffAttendanceReport
                prevAllFilters={allFilters}
                userInfoData={user}
              />
            </Col>
          </Row>
        )} */}
      </Container>
    </HelmetWrapper>
  );
};

export default TrainerReport;
